import React from "react";
import { FiltersTypes } from "@common/types/filters/general";

interface UnreadFilterLabelProps {
    filters: Pick<FiltersTypes, "hasUnread">;
}

export const UnreadFilterLabel: React.FC<UnreadFilterLabelProps> = ({
    filters: { hasUnread },
}) => {
    if (hasUnread === true) {
        return <span>Has unread</span>;
    }
    if (hasUnread === false) {
        return <span>No unread</span>;
    }
    return null;
};
